import styled from 'styled-components'

export default styled.h2`
  margin: 0;
  padding: 0 0 8px 0;
  font-family: "Circular", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #8C8C8C;
  display: inline-block;
  text-transform: ${props => props.title ? 'uppercase' : 'none'};
`
